export function useCurrencyCalc({
    currencyBuyRates,
    currencySellRates,
    currentRateData,
    createOrder,
    setCreateOrder,
    setBuyCurrencyForInfo,
}: any) {

    const getIban = (
        from: string,
        to: string,
        side: "BUY" | "SELL"
    ) => {
        const pair1 = `${from}/${to}`;
        const pair2 = `${to}/${from}`;

        const rate = currentRateData.find(
            (r: any) => r.code === pair1 || r.code === pair2
        );

        if (!rate) return "";

        if (rate.code === pair1) {
            return side === "SELL" ? rate.sellIBAN : rate.buyIBAN;
        }

        return side === "SELL" ? rate.buyIBAN : rate.sellIBAN;
    };


    const getGelRate = (
        rates: Record<string, number>,
        currency: string
    ): number => {
        if (currency === "GEL") return 1;
        
        const rate = rates[`${currency}_GEL`];
        return rate ?? NaN;
    };


    const calculateRate = (
        amount: number,
        from: string,
        to: string,
        side: "BUY" | "SELL",
        buyRates: Record<string, number>,
        sellRates: Record<string, number>
    ): number => {
        if (from === to) return amount;

        if (side === "SELL") {
            
            // amount * Buy(from→GEL) / Sell(to→GEL)
            const fromBuy = getGelRate(buyRates, from);
            const toSell = getGelRate(sellRates, to);
            
            
            if (!fromBuy || !toSell) return NaN;

            return amount * (fromBuy / toSell);
        }

        // BUY
        // amount * Sell(from→GEL) / Buy(to→GEL)
        const fromSell = getGelRate(sellRates, from);
        const toBuy = getGelRate(buyRates, to);
        
        if (!fromSell || !toBuy) return NaN;

        return amount * (fromSell / toBuy);
    };

    const convert = ({
        amount,
        from,
        to,
        side,
    }: {
        amount: number | string;
        from: string;
        to: string;
        side: "BUY" | "SELL";
    }) => {
        if (!amount || from === to) return "";

        const numericAmount = Number(amount);
        
        const result = calculateRate(
            numericAmount,
            from,
            to,
            side,
            currencyBuyRates,
            currencySellRates
        );

        if (isNaN(result)) return "0.00";

        const fixed = result.toFixed(4);

        setBuyCurrencyForInfo(result / numericAmount);

        setCreateOrder({
            ...createOrder,
            sourceCurrency: from,
            targetCurrency: to,
            amount,
            result: fixed,
            bankAccount: getIban(from, to, side),
        });

        return fixed;
    };

    return { convert };
}
